import { useQuery, useQueryClient } from '@tanstack/react-query';
import ByesList from './ByesList';
import { api } from '../../AppConfig';


function Byes() {
  // Access the client
  // const queryClient = useQueryClient();

  // console.warn('che id mi viene passato?', id);

  //otherwise we fetch the data and pass to the display component
  const byesQuery = useQuery({ 
    queryKey: ['byes'], 
    queryFn: () => 
      fetch(api.byes().list().href).then((res) =>
        res.json(), 
      )
  })

  return <ByesList 
            pending={byesQuery.isPending} 
            byes={byesQuery.data} 
  />;
}

export default Byes;